import { Data } from "@gaming/srvg-classes-core";
import { Matchset } from "./SporteventSet/Matchset";

export class Match extends Data {
    id: number;
    matchset: Matchset;
    start: number;
    betstop: number;
    end: number;
    homeClubId: number;
    awayClubId: number;
    chunk_id: number;

    constructor( id: number, matchset: Matchset, start: number, betstop:number, end: number, homeClubId: number, awayClubId: number, chunk_id: number ) {
        super();
        this.id = id;
        this.matchset = matchset;
        this.start = start;
        this.betstop = betstop;
        this.end = end;
        this.homeClubId = homeClubId;
        this.awayClubId = awayClubId;
        this.chunk_id = chunk_id;
    }
}